import { format } from 'date-fns';
import React from 'react';
import { Button } from 'reactstrap';
import DeleteIcon from '../../Res/Icon/delete.png';
import CallsPlayer from './CallsPlayer';
import utils from '../../lib/utils';

const TableRowIn = ({ calls, onDelete, user, deleteMode, onRecover }) => {
  return (
    <tr>
      <td>{calls.company.name || ''}</td>
      <td>{calls.calledNumber || ''}</td>
      <td>{calls.callingNumber || ''}</td>
      <td>{calls.duration || ''}</td>
      <td>{utils.getDateTimeFormat(calls.date, 'both')}</td>
      <td>{calls.forwardNumber || ''}</td>
      {!deleteMode ? (
        <td style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          {user.role !== 'companyGroupAdmin' &&
            user.role !== 'companyGroupManager' &&
            user.role !== 'admin' ? (
            <>
              <Button
                // color="danger"
                style={{ background: 'inherit', padding: '0', border: 'none' }}
                onClick={() => {
                  onDelete(calls._id);
                }}
                title="Delete"
              >
                {/* <FontAwesomeIcon icon="trash-alt" /> */}
                <img style={{ width: '2rem', height: '2rem' }} src={DeleteIcon} alt="delete" />
              </Button>
            </>
          ) : null}

          {calls.recordingPath && calls.recordingPath !== null && (
            <CallsPlayer id={calls._id} type="incomingRecording" />
          )}
        </td>
      ) : (
        <td style={{ display: 'flex', justifyContent: 'space-evenly' }}>
          <Button
            // color="danger"
            style={{ background: 'inherit', padding: '0', border: 'none', marginRight: '20px' }}
            onClick={() => {
              onDelete(calls._id);
            }}
          >
            {/* Delete */}
            <img style={{ width: '2rem', height: '2rem' }} src={DeleteIcon} alt="delete" />
          </Button>
          <Button
            color="info"
            style={{ marginRight: '20px' }}
            onClick={() => {
              onRecover(calls._id);
            }}
          >
            Recover
          </Button>
        </td>
      )}
    </tr>
  );
};

export default React.memo(TableRowIn);
